import { Box, Typography } from '@mui/material';
import { useTranslation } from 'modules/i18n';
import { translation } from './translation';

import { useBreakpoints } from 'modules/common/hooks/useBreakpoints';
import { default as CantinaIcon } from './assets/cantina.svg?react';
import { default as MacroIcon } from './assets/macro.svg?react';
import { BlurredStack } from 'modules/common/components/BlurredStack';

export function Audits(): JSX.Element {
  const { t, keys } = useTranslation(translation);
  const { isSmDown } = useBreakpoints();

  return (
    <Box mt={4.5}>
      <Typography variant="subtitle1" fontWeight={500}>
        {t(keys.title)}
      </Typography>

      <BlurredStack
        gap={isSmDown ? 3 : 12}
        mt={2}
        py={4.5}
        px={2.5}
        flexDirection={isSmDown ? 'column' : 'row'}
        alignItems="center"
        justifyContent="center"
        sx={{
          borderRadius: 1.2,
        }}
      >
        <Box component={CantinaIcon} />

        <Box component={MacroIcon} />
      </BlurredStack>
    </Box>
  );
}
